import { SelfFundedOfferComponent } from 'features/rewards/helpers/formatSelfFundedOfferComponents';
import useSelfFundedOfferComponents from 'features/rewards/hooks/useSelfFundedOfferComponents';
import { SectionedContentScreenSection } from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

interface UseSelfFundedOffersV2Response {
  selfFundedOffersSection: SectionedContentScreenSection[];
  loading: boolean;
}
const useSelfFundedOffersV2 = (): UseSelfFundedOffersV2Response => {
  const { offerCards: selfFundedOffers, loading } =
    useSelfFundedOfferComponents();

  const createSectionHeader = (
    offers?: SelfFundedOfferComponent[],
  ): VXLNode | undefined => {
    const offerWithTitle = offers?.find(
      (offer) => 'sectionTitle' in offer && offer.sectionTitle,
    );

    if (
      !offerWithTitle ||
      !('sectionTitle' in offerWithTitle) ||
      !offerWithTitle.sectionTitle
    ) {
      return undefined;
    }

    return {
      id: 'selfFundedOffersSectionHeader',
      name: VXLComponentId.SECTION_DIVIDER,
      props: {
        labelText: offerWithTitle.sectionTitle.text,
        background: theme.color.background.tertiary,
        textSize: 'large',
      },
    };
  };

  const selfFundedOfferNodes: VXLNode[] = selfFundedOffers
    ? selfFundedOffers.map((offer: SelfFundedOfferComponent) => {
        const { type, ...props } = offer;

        // Handle standard offer cards - displays non-activated offers
        if (type === 'offer-card') {
          return {
            id: offer.id,
            name: VXLComponentId.OFFER_CARD,
            props,
          };
        } else if (type === 'activated-offer-card') {
          // Handle activated offer cards - displays offers that user has already activated
          return {
            id: offer.offerId,
            name: VXLComponentId.ACTIVATED_OFFER_CARD,
            props,
          };
        }
        // Fallback for unknown offer types
        return {
          id: 'unknown',
          name: VXLComponentId.OFFER_CARD,
          props: {},
        };
      })
    : [];

  const selfFundedOffersSection: SectionedContentScreenSection[] =
    selfFundedOfferNodes.length
      ? [
          {
            sectionHeader: createSectionHeader(selfFundedOffers),
            sectionFooter: undefined,
            data: selfFundedOfferNodes,
          },
        ]
      : [];

  return {
    selfFundedOffersSection,
    loading,
  };
};

export default useSelfFundedOffersV2;
